export default __webpack_public_path__ + "static/media/wallet.d91b3268.svg";